/* eslint-disable max-lines */
/* eslint-disable indent */
import {
  Container,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Card,
  CardHeader,
  CardBody,
  Button,
  UncontrolledTooltip,
  Badge,
} from 'reactstrap';
import React, { useContext, useState, useEffect, useRef, ChangeEvent } from 'react';
import { toast } from 'react-toastify';
import { Context as AuthContext } from '../../../../contexts/AuthContext';
import CommonHeader from '../../../../components/Headers/CommonHeader';
import { PagedMetaInterface, createPagedMeta } from '../../../../entities/PagedMeta';
import { createOptionsPage } from '../../../../entities/OptionsPaged';
import moment from 'moment';
import BulkImportModal from './BulkImportModal';
import DeductionModal from './DeductionModal';
import ExtraPaymentModal from './ExtraPaymentModal';
import RaiseModal from './RaiseModal';
import BonusesModal from './BonusesModal';
import CoverSheetModal from './CoverSheetModal';
import Employee from '../../../../services/Employee';
import PayCodesService from '../../../../services/PayCodes';
import PayrollService from '../../../../services/Payroll';
import DeductionDetail from './DeductionDetail';
import ExtraPaymentDetail from './ExtraPaymentDetail';
import RaiseDetail from './RaiseDetail';
import BonusesDetail from './BonusesDetail';
import PayrollColumns from './datatableCollumns/PayrollColumns';
import DeductionsColumns from './datatableCollumns/DeductionsColumns';
import ExtraPaymentColumns from './datatableCollumns/ExtraPaymentColumns';
import RaisesColumns from './datatableCollumns/RaisesColumns';
import BonusesColumns from './datatableCollumns/BonusesColumns';
import PayrollTab from './tabsItem/PayrollTab';
import DeductionsTab from './tabsItem/DeductionsTab';
import ExtraPaymentTab from './tabsItem/ExtraPaymentTab';
import RaisesTab from './tabsItem/RaisesTab';
import BonusesTab from './tabsItem/BonusesTab';
import SubmittedTab from './tabsItem/SubmittedTab';
import { PayrollOverviewCardInfo } from './PayrollOverviewCardInfo';
import WeekHero from './WeekHero';
import Can from '../../../../components/Core/Can';
import { downloadFromUrl } from '../../../../helpers/downloadFromUrl';

const Payroll = () => {
  const { token, currentSchool }: any = useContext(AuthContext);
  const ghostActionStyle = { color: '#32325d', borderColor: '#e9ecef', background: '#fff' };
  const downloadActionStyle = { background: '#3b82c4', borderColor: '#3b82c4', color: '#fff' };
  const [activeTab, setActiveTab] = useState<
    'payroll' | 'deductions' | 'extraPayments' | 'raises' | 'bonuses' | 'submitted'
  >('payroll');
  const [isOpen, setIsOpen] = useState(false);
  const [payCodes, setPayCodes] = useState([] as any[]);

  const [deductionDetailsData, setDeductionDetailsData] = useState<any>();
  const [isDeductionDetailsOpen, setIsDeductionDetailsOpen] = useState(false);

  const [extraPaymentDetailsData, setExtraPaymentDetailsData] = useState<any>();
  const [isExtraPaymentDetailsOpen, setIsExtraPaymentDetailsOpen] = useState(false);

  const [raiseDetailsData, setRaiseDetailsData] = useState<any>();
  const [isRaiseDetailsOpen, setIsRaiseDetailsOpen] = useState(false);

  const [bonusesDetailsData, setBonusesDetailsData] = useState<any>();
  const [isBonusesDetailsOpen, setIsBonusesDetailsOpen] = useState(false);

  const _toggle = () => {
    setIsOpen(!isOpen);
  };

  const [submitPayrollLoading, setSubmitPayrollLoading] = useState(false);

  const handleSubmitPayroll = async () => {
    if (
      !currentSchool?.value ||
      coverSheetStatusLoading ||
      !coverSheetStatus.exists ||
      coverSheetStatus.status !== 'APPROVED'
    ) {
      return;
    }
    setSubmitPayrollLoading(true);
    try {
      const startDate = moment(selectedWeekStart).format('YYYY-MM-DD');
      const endDate = moment(selectedWeekStart).endOf('isoWeek').format('YYYY-MM-DD');
      await PayrollService(token).coverSheetSubmit(currentSchool.value, { periodStart: startDate, periodEnd: endDate });
      toast.success('Payroll submitted successfully');
      const result = await PayrollService(token).coverSheetGetStatus(currentSchool.value, startDate, endDate);
      setCoverSheetStatus(result?.data || { exists: false });
    } catch (e: any) {
      toast.error(e?.response?.data?.message || 'Error submitting payroll');
    } finally {
      setSubmitPayrollLoading(false);
    }
  };

  const [downloadPayrollLoading, setDownloadPayrollLoading] = useState(false);

  const handleDownloadPayroll = async () => {
    if (!currentSchool?.value || !coverSheetStatus.submitted) return;
    setDownloadPayrollLoading(true);
    try {
      const startDate = moment(selectedWeekStart).format('YYYY-MM-DD');
      const endDate = moment(selectedWeekStart).endOf('isoWeek').format('YYYY-MM-DD');
      const response = await PayrollService(token).payrollDownload(currentSchool.value, startDate, endDate, 'zip');
      const downloadUrl = response?.data?.downloadUrl;
      if (downloadUrl) {
        const schoolLabel = (currentSchool?.label || 'School').replace(/\s+/g, '_');
        const filename = `Payroll_${startDate}_${endDate}_${schoolLabel}.zip`;
        await downloadFromUrl(downloadUrl, filename);
      } else {
        toast.error('Error getting download link');
      }
    } catch (e: any) {
      toast.error(e?.response?.data?.message || 'Error downloading payroll');
    } finally {
      setDownloadPayrollLoading(false);
    }
  };

  const customStyles = {
    navLink: {
      minHeight: '42px',
      paddingTop: '8px',
      cursor: 'pointer',
    },
  };

  const [data, setData] = useState([] as any[]);
  const [deductionsData, setDeductionsData] = useState([] as any[]);
  const [extraPaymentsData, setExtraPaymentsData] = useState([] as any[]);
  const [raiseData, setRaiseData] = useState([] as any[]);
  const [bonusesData, setBonusesData] = useState([] as any[]);

  const [loading, setLoading] = useState(false);
  const [searchStaffNameByPayroll] = useState('');
  const [searchStaffNameByBulkImport, setSearchStaffNameByBulkImport] = useState('');

  const [searchStaffNameByDeductions] = useState('');
  const [searchStaffNameByExtraPayments] = useState('');
  const [searchStaffNameByRaises] = useState('');
  const [searchStaffNameByBonuses] = useState('');

  const [employees, setEmployees] = useState<any[]>();
  const [employeesByBulkImport, setEmployeesByBulkImport] = useState<any[]>();

  const [isBulkImportOpen, setIsBulkImportOpen] = useState(false);
  const [isBulkImportFormOpen, setIsBulkImportFormOpen] = useState(false);
  const [isSelectedAllStaff, setIsSelectedAllStaff] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState([] as any[]);
  const [payCode, setPayCode] = useState('');
  const [isDeductionOpen, setIsDeductionOpen] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const [isExtraPaymentOpen, setIsExtraPaymentOpen] = useState(false);
  const [extraPaymentStaff, setExtraPaymentStaff] = useState('');
  const [extraPaymentType, setExtraPaymentType] = useState('');
  const [extraPaymentAmount, setExtraPaymentAmount] = useState('');
  const [extraPaymentAddingDate, setExtraPaymentAddingDate] = useState(moment().format());
  const [extraPaymentReason, setExtraPaymentReason] = useState('');
  const [extraPaymentDocumentSelected, setExtraPaymentDocumentSelected] = useState<any>();
  const documentInputRef = useRef<HTMLInputElement>(null);
  const [extraPaymentReceiptSelected, setExtraPaymentReceiptSelected] = useState<any>();
  const receiptInputRef = useRef<HTMLInputElement>(null);

  const [isRaiseOpen, setIsRaiseOpen] = useState(false);
  const [raiseStaff, setRaiseStaff] = useState('');
  const [raiseAmount, setRaiseAmount] = useState('');
  const [raiseCurrentAmount, setRaiseCurrentAmount] = useState('');
  const [raiseDateItBecomesEffectiveOn, setRaiseDateItBecomesEffectiveOn] = useState(moment().format());
  const [raiseReason, setRaiseReason] = useState('');
  const [raiseFileSelected, setRaiseFileSelected] = useState<any>();

  const [isBonusesOpen, setIsBonusesOpen] = useState(false);
  const [bonusesStaff, setBonusesStaff] = useState('');
  const [bonusesAmount, setBonusesAmount] = useState('');
  const [bonusesDateItBecomesEffectiveOn, setBonusesDateItBecomesEffectiveOn] = useState(moment().format());
  const [bonusesReason, setBonusesReason] = useState('');
  const [bonusesNumberOfPayments, setBonusesNumberOfPayments] = useState('');

  const [isCoverSheetOpen, setIsCoverSheetOpen] = useState(false);
  const [selectedWeekStart, setSelectedWeekStart] = useState(moment().startOf('isoWeek').format('YYYY-MM-DD'));
  const [coverSheetStatus, setCoverSheetStatus] = useState<{
    exists: boolean;
    status?: 'PENDING' | 'APPROVED' | 'REJECTED';
    submitted?: boolean;
  }>({ exists: false });
  const [coverSheetStatusLoading, setCoverSheetStatusLoading] = useState(false);

  const coverSheetStartDate = moment(selectedWeekStart).format('MM/DD/YYYY');
  const coverSheetEndDate = moment(selectedWeekStart).endOf('isoWeek').format('MM/DD/YYYY');

  const currentWeekStart = moment().startOf('isoWeek').format('YYYY-MM-DD');
  const isCurrentWeek = selectedWeekStart === currentWeekStart;

  const stepWeek = (delta: number) => {
    const newStart = moment(selectedWeekStart)
      .add(delta * 7, 'days')
      .startOf('isoWeek')
      .format('YYYY-MM-DD');
    setSelectedWeekStart(newStart);
  };

  const goToThisWeek = () => setSelectedWeekStart(currentWeekStart);

  const handleRaiseFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectFile = event.target.files?.[0];
    if (selectFile) {
      setRaiseFileSelected(selectFile);
    }
  };

  const handleDocumentChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectFile = event.target.files?.[0];
    if (selectFile) {
      setExtraPaymentDocumentSelected(selectFile);
    }
  };

  const handleReceiptChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectFile = event.target.files?.[0];
    if (selectFile) {
      setExtraPaymentReceiptSelected(selectFile);
    }
  };

  const handleCustomButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleCustomButtonDocumentClick = () => {
    if (documentInputRef.current) {
      documentInputRef.current.click();
    }
  };

  const handleCustomButtonReceiptClick = () => {
    if (receiptInputRef.current) {
      receiptInputRef.current.click();
    }
  };

  const handleApprove = async (id: string) => {
    try {
      await PayrollService(token).raiseApprove(id);
      loadRaises();
    } catch (err: any) {
      toast.error(err?.response?.data?.message || 'Error approving raise');
    }
  };

  const handleRepprove = async (id: string) => {
    try {
      await PayrollService(token).raiseRepprove(id);
      loadRaises();
    } catch (err: any) {
      toast.error(err?.response?.data?.message || 'Error reprroving raise');
    }
  };

  useEffect(() => {
    const fetchCoverSheetStatus = async () => {
      if (!selectedWeekStart || !currentSchool?.value) {
        return;
      }

      setCoverSheetStatusLoading(true);
      try {
        const startDate = moment(selectedWeekStart).format('YYYY-MM-DD');
        const endDate = moment(selectedWeekStart).endOf('isoWeek').format('YYYY-MM-DD');
        const result = await PayrollService(token).coverSheetGetStatus(currentSchool.value, startDate, endDate);
        setCoverSheetStatus(result?.data || { exists: false });
      } catch (error) {
        setCoverSheetStatus({ exists: false });
      } finally {
        setCoverSheetStatusLoading(false);
      }
    };

    fetchCoverSheetStatus();
  }, [selectedWeekStart, currentSchool?.value, token]);

  const columnsPayroll = PayrollColumns();
  const handleApproveDeduction = async (row: any) => {
    try {
      await PayrollService(token).deductionApprove(row.id);
      toast.success('Deduction approved!');
      loadDeductions();
    } catch (e: any) {
      toast.error(String(e?.response?.data?.message || 'Error approving deduction'));
    }
  };

  const handleRejectDeduction = async (row: any) => {
    try {
      await PayrollService(token).deductionReject(row.id);
      toast.success('Deduction rejected!');
      loadDeductions();
    } catch (e: any) {
      toast.error(String(e?.response?.data?.message || 'Error rejecting deduction'));
    }
  };

  const columnsDeductions = DeductionsColumns({
    setDeductionDetailsData,
    setIsDeductionDetailsOpen,
    onApprove: handleApproveDeduction,
    onReject: handleRejectDeduction,
  });
  const columnsExtraPayment = ExtraPaymentColumns({
    setExtraPaymentDetailsData,
    setIsExtraPaymentDetailsOpen,
  });
  const columnsRaises = RaisesColumns({
    setRaiseDetailsData,
    setIsRaiseDetailsOpen,
    handleApprove,
    handleRepprove,
  });
  const handleApproveBonuses = async (row: any) => {
    try {
      await PayrollService(token).bonusesApprove(row.id);
      toast.success('Bonus approved!');
      loadBonuses();
    } catch (e: any) {
      toast.error(String(e?.response?.data?.message || 'Error approving bonus'));
    }
  };

  const handleRejectBonuses = async (row: any) => {
    try {
      await PayrollService(token).bonusesReject(row.id);
      toast.success('Bonus rejected!');
      loadBonuses();
    } catch (e: any) {
      toast.error(String(e?.response?.data?.message || 'Error rejecting bonus'));
    }
  };

  const columnsBonuses = BonusesColumns({
    setBonusesDetailsData,
    setIsBonusesDetailsOpen,
    onApprove: handleApproveBonuses,
    onReject: handleRejectBonuses,
  });

  const toggleBulkImport = () => setIsBulkImportOpen(!isBulkImportOpen);

  const toggleBulkImportForm = () => setIsBulkImportFormOpen(!isBulkImportFormOpen);

  const toggleDeduction = () => setIsDeductionOpen(!isDeductionOpen);

  const toggleExtraPayment = () => setIsExtraPaymentOpen(!isExtraPaymentOpen);

  const toggleRaise = () => setIsRaiseOpen(!isRaiseOpen);

  const toggleBonuses = () => setIsBonusesOpen(!isBonusesOpen);

  const toggleCoverSheet = () => setIsCoverSheetOpen(!isCoverSheetOpen);

  const [pagedMeta, setPagedMeta] = useState(createPagedMeta());
  const [filteredOptions, setFilteredOptions] = useState({
    filters: [],
    options: createOptionsPage(pagedMeta),
  });

  useEffect(() => {
    loadStaff();
  }, []);

  const loadStaff = async () => {
    const result = await Employee(token).listEmployeesBySchool(currentSchool.value);
    setEmployees(result?.data);
  };

  useEffect(() => {
    const loadPayroll = async () => {
      try {
        setLoading(true);
        const weekStartDate = moment(selectedWeekStart).format('YYYY-MM-DD');
        const weekEndDate = moment(selectedWeekStart).endOf('isoWeek').format('YYYY-MM-DD');

        const result = await PayrollService(token).timecardListWithPending(currentSchool.value, {
          weekStartDate,
          weekEndDate,
          page: pagedMeta.currentPage,
          limit: pagedMeta.perPage,
        });

        const rows = (result.data || []).map((item: any) => {
          const emp = item.employee || {};
          const tc = item.timecard;
          return {
            ...emp,
            ...(tc || {}),
            user: emp.user,
            currentPayRate: emp.currentPayRate,
            workedHours: item?.workedHours ?? item.pendingWorkedHours ?? undefined,
            overtimeHours: item.overtimeHours,
            ptoHours: item?.ptoHours,
            trainingHours: item?.trainingHours,
            scheduledWeeklyHours: item.scheduledWeeklyHours,
            totalWorkedHours: item?.totalWorkedHours,
          };
        });
        setData(rows);

        const meta: PagedMetaInterface = result.meta;
        if (meta) {
          setPagedMeta(meta);
        }
      } catch (e: any) {
        const message = String(e?.response?.data?.message || 'Error fetching timecards');
        return toast.error(message);
      } finally {
        setLoading(false);
      }
    };

    loadPayroll();
  }, [
    selectedWeekStart,
    searchStaffNameByPayroll,
    pagedMeta.currentPage,
    pagedMeta.perPage,
    currentSchool.value,
    token,
  ]);

  useEffect(() => {
    loadDeductions();
  }, [searchStaffNameByDeductions, selectedWeekStart]);

  useEffect(() => {
    loadExtraPayments();
  }, [searchStaffNameByExtraPayments, selectedWeekStart]);

  useEffect(() => {
    loadRaises();
  }, [searchStaffNameByRaises, selectedWeekStart]);

  useEffect(() => {
    loadBonuses();
  }, [searchStaffNameByBonuses, selectedWeekStart]);

  useEffect(() => {
    const loadEmployeesByBulkImport = async () => {
      const result = await Employee(token).listEmployeesBySchool(currentSchool.value, searchStaffNameByBulkImport, {
        filters: [],
        options: createOptionsPage(createPagedMeta({ perPage: 1000 })),
      });
      setEmployeesByBulkImport(result?.data);
    };
    loadEmployeesByBulkImport();
  }, [searchStaffNameByBulkImport]);

  useEffect(() => {
    if (isBulkImportFormOpen) {
      listTypes();
    }
  }, [isBulkImportFormOpen]);

  const listTypes = async () => {
    try {
      const result = await PayCodesService(token).list();
      setPayCodes(result.data || []);
    } catch (e: any) {
      toast.error(e?.response?.data?.message || 'No Types Found!');
    }
  };

  const loadDeductions = async () => {
    try {
      const startDate = moment(selectedWeekStart).format('YYYY-MM-DD');
      const endDate = moment(selectedWeekStart).endOf('isoWeek').format('YYYY-MM-DD');

      const filters: any[] = [
        { field: 'startDate', operation: '>=', value: startDate },
        { field: 'startDate', operation: '<=', value: endDate },
      ];

      const filterParams: Record<string, string> = {};
      filters.forEach((filter, index) => {
        filterParams[`filters[${index}][field]`] = filter.field;
        filterParams[`filters[${index}][operation]`] = filter.operation;
        filterParams[`filters[${index}][value]`] = filter.value;
      });

      const result = await PayrollService(token).deductionList(
        currentSchool.value,
        searchStaffNameByDeductions,
        filterParams,
      );
      setDeductionsData(result?.data);
    } catch (e: any) {
      const message = String(e?.response?.data?.message || 'Error fetching list');
      return toast.error(message);
    }
  };

  const loadExtraPayments = async () => {
    try {
      const startDate = moment(selectedWeekStart).format('YYYY-MM-DD');
      const endDate = moment(selectedWeekStart).endOf('isoWeek').format('YYYY-MM-DD');

      const filters: any[] = [
        { field: 'dateAddingToPayroll', operation: '>=', value: startDate },
        { field: 'dateAddingToPayroll', operation: '<=', value: endDate },
      ];

      const filterParams: Record<string, string> = {};
      filters.forEach((filter, index) => {
        filterParams[`filters[${index}][field]`] = filter.field;
        filterParams[`filters[${index}][operation]`] = filter.operation;
        filterParams[`filters[${index}][value]`] = filter.value;
      });

      const result = await PayrollService(token).extraPaymentList(
        currentSchool.value,
        searchStaffNameByExtraPayments,
        filterParams,
      );
      setExtraPaymentsData(result?.data);
    } catch (e: any) {
      const message = String(e?.response?.data?.message || 'Error fetching list');
      return toast.error(message);
    }
  };

  const loadRaises = async () => {
    try {
      const startDate = moment(selectedWeekStart).format('YYYY-MM-DD');
      const endDate = moment(selectedWeekStart).endOf('isoWeek').format('YYYY-MM-DD');

      const filters: any[] = [
        { field: 'dateItBecomesEffectiveOn', operation: '>=', value: startDate },
        { field: 'dateItBecomesEffectiveOn', operation: '<=', value: endDate },
      ];

      const filterParams: Record<string, string> = {};
      filters.forEach((filter, index) => {
        filterParams[`filters[${index}][field]`] = filter.field;
        filterParams[`filters[${index}][operation]`] = filter.operation;
        filterParams[`filters[${index}][value]`] = filter.value;
      });

      const result = await PayrollService(token).raiseList(currentSchool.value, searchStaffNameByRaises, filterParams);
      setRaiseData(result?.data);
    } catch (e: any) {
      const message = String(e?.response?.data?.message || 'Error fetching list');
      return toast.error(message);
    }
  };

  const loadBonuses = async () => {
    try {
      const startDate = moment(selectedWeekStart).format('YYYY-MM-DD');
      const endDate = moment(selectedWeekStart).endOf('isoWeek').format('YYYY-MM-DD');

      const filters: any[] = [
        { field: 'dateItBecomesEffectiveOn', operation: '>=', value: startDate },
        { field: 'dateItBecomesEffectiveOn', operation: '<=', value: endDate },
      ];

      const filterParams: Record<string, string> = {};
      filters.forEach((filter, index) => {
        filterParams[`filters[${index}][field]`] = filter.field;
        filterParams[`filters[${index}][operation]`] = filter.operation;
        filterParams[`filters[${index}][value]`] = filter.value;
      });

      const result = await PayrollService(token).bonusesList(
        currentSchool.value,
        searchStaffNameByBonuses,
        filterParams,
      );
      setBonusesData(result?.data);
    } catch (e: any) {
      const message = String(e?.response?.data?.message || 'Error fetching list');
      return toast.error(message);
    }
  };

  const handlePerRowsChange = async (perPage: number) => {
    const newOptions = {
      ...pagedMeta,
      perPage,
    };
    const newFilteredOptions = {
      filters: filteredOptions.filters,
      options: createOptionsPage(newOptions),
    };
    setFilteredOptions(newFilteredOptions);
  };

  const handlePageChange = async (page: number) => {
    const newOptions = {
      ...pagedMeta,
      currentPage: page,
    };
    const newFilteredOptions = {
      filters: filteredOptions.filters,
      options: createOptionsPage(newOptions),
    };
    setFilteredOptions(newFilteredOptions);
  };

  useEffect(() => {
    if (selectedStaff.length === employeesByBulkImport?.length) {
      setIsSelectedAllStaff(true);
    } else {
      setIsSelectedAllStaff(false);
    }
  }, [employeesByBulkImport]);

  useEffect(() => {
    if (raiseStaff && employees) {
      const user = employees?.find((user) => user.userId === raiseStaff);
      const oldAmount = parseFloat(user.payRate).toLocaleString('en-IN', {
        style: 'currency',
        currency: 'USD',
      });
      setRaiseCurrentAmount(String(oldAmount).replaceAll(',', ''));
    }
  }, [raiseStaff, employees]);

  const handleSelectStaff = (staff: any) => {
    const foundStaff = selectedStaff.find((selected) => selected.id === staff.id);

    if (foundStaff) {
      const newSelectedStaff = selectedStaff.filter((selected) => selected.id !== staff.id);
      setSelectedStaff(newSelectedStaff);
      if (newSelectedStaff.length === employees?.length) {
        setIsSelectedAllStaff(true);
      } else {
        setIsSelectedAllStaff(false);
      }
    } else {
      const newSelectedStaff = selectedStaff;
      newSelectedStaff.push(staff);
      setSelectedStaff(newSelectedStaff);
      if (newSelectedStaff.length === employees?.length) {
        setIsSelectedAllStaff(true);
      } else {
        setIsSelectedAllStaff(false);
      }
    }
  };

  const handleToggleSelectAllStaff = () => {
    if (isSelectedAllStaff) {
      setSelectedStaff([]);
      setIsSelectedAllStaff(false);
    } else {
      setSelectedStaff(employeesByBulkImport || []);
      setIsSelectedAllStaff(true);
    }
  };

  const handleDeductionCreated = (result: { success: boolean }) => {
    if (!result?.success) return;
    loadDeductions();
    toggleDeduction();
  };

  const handleSubmitExtraPayment = async (event: React.FormEvent) => {
    event.preventDefault();

    if ((extraPaymentType === 'Health Care' || extraPaymentType === 'Reimbursement') && !extraPaymentDocumentSelected) {
      toast.error('Document is required');
      return;
    }

    if (extraPaymentType === 'Reimbursement' && !extraPaymentReceiptSelected) {
      toast.error('Receipt is required');
      return;
    }

    const data: any = {
      userId: extraPaymentStaff,
      schoolId: currentSchool.value,
      type: extraPaymentType,
      amount: parseFloat(extraPaymentAmount.replace('$', '')),
      reason: extraPaymentReason,
      dateAddingToPayroll: extraPaymentAddingDate,
    };

    try {
      const result = await PayrollService(token).extraPaymentCreate(data);

      if (extraPaymentDocumentSelected) {
        const formDataDocument = new FormData();
        formDataDocument.append('file', extraPaymentDocumentSelected as any);
        await PayrollService(token).extraPaymentDocument(result?.data?.id, formDataDocument);
      }

      if (extraPaymentReceiptSelected) {
        const formDataReceipt = new FormData();
        formDataReceipt.append('file', extraPaymentReceiptSelected as any);
        await PayrollService(token).extraPaymentReceipt(result?.data?.id, formDataReceipt);
      }

      toast.success(`Saved successfully!`);

      toggleExtraPayment();
      loadExtraPayments();
      setExtraPaymentStaff('');
      setExtraPaymentType('');
      setExtraPaymentAmount('');
      setExtraPaymentReason('');
      setExtraPaymentAddingDate(moment().format());
    } catch (e: any) {
      const message = String(e?.response?.data?.message || 'Error to create');
      toast.error(message);
    }
  };

  const handleSubmitRaise = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!raiseFileSelected) {
      toast.error('File is required');
      return;
    }

    const data: any = {
      userId: raiseStaff,
      schoolId: currentSchool.value,
      amount: parseFloat(raiseAmount.replace('$', '')),
      oldAmount: parseFloat(raiseCurrentAmount.replace('$', '')),
      reason: raiseReason,
      dateItBecomesEffectiveOn: raiseDateItBecomesEffectiveOn,
    };

    try {
      const result = await PayrollService(token).raiseCreate(data);

      if (raiseFileSelected) {
        const formDataDocument = new FormData();
        formDataDocument.append('file', raiseFileSelected as any);
        await PayrollService(token).raiseFile(result?.data?.id, formDataDocument);
      }

      toast.success(`Saved successfully!`);

      toggleRaise();
      loadRaises();
      setRaiseStaff('');
      setRaiseCurrentAmount('');
      setRaiseAmount('');
      setRaiseReason('');
      setRaiseFileSelected(null);
      setRaiseDateItBecomesEffectiveOn(moment().format());
    } catch (e: any) {
      const message = String(e?.response?.data?.message || 'Error to create');
      toast.error(message);
    }
  };

  const handleSubmitBonuses = async (event: React.FormEvent) => {
    event.preventDefault();

    const data: any = {
      userId: bonusesStaff,
      schoolId: currentSchool.value,
      amount: parseFloat(bonusesAmount.replace('$', '')),
      reason: bonusesReason,
      dateItBecomesEffectiveOn: bonusesDateItBecomesEffectiveOn,
    };

    const numberOfPayments = parseInt(bonusesNumberOfPayments, 10);
    if (numberOfPayments && numberOfPayments > 1) {
      data.numberOfPayments = numberOfPayments;
    }

    try {
      await PayrollService(token).bonusesCreate(data);

      toast.success(`Saved successfully!`);

      toggleBonuses();
      loadBonuses();
      setBonusesStaff('');
      setBonusesAmount('');
      setBonusesReason('');
      setBonusesNumberOfPayments('');
      setBonusesDateItBecomesEffectiveOn(moment().format());
    } catch (e: any) {
      const message = String(e?.response?.data?.message || 'Error to create');
      toast.error(message);
    }
  };

  const getTotalByTab = (tabKey: string) => {
    switch (tabKey) {
      case 'payroll':
        return data?.length || 0;
      case 'deductions':
        return deductionsData?.length || 0;
      case 'bonuses':
        return bonusesData?.length || 0;
      case 'extraPayments':
        return extraPaymentsData?.length || 0;
      case 'raises':
        return raiseData?.length || 0;
      case 'submitted':
        return 0;
      default:
        return 0;
    }
  };

  const payrollRowStyles = [
    {
      when: (row: any) => row.status === 'REVIEWED_APPROVED',
      style: { backgroundColor: 'rgb(212, 255, 225)' },
    },
    {
      when: (row: any) => row.status === 'REVIEWED_REJECTED',
      style: { backgroundColor: '#e4605e', color: 'white' },
    },
  ];

  const payrollTabs = {
    payroll: {
      content: (
        <PayrollTab
          columns={columnsPayroll}
          data={data}
          pagedMeta={pagedMeta}
          loading={loading}
          handlePerRowsChange={handlePerRowsChange}
          handlePageChange={handlePageChange}
          conditionalRowStyles={payrollRowStyles}
        />
      ),
      name: 'Payroll',
      icon: 'fas fa-money-check-alt',
      visible: true,
    },
    deductions: {
      content: (
        <DeductionsTab
          columns={columnsDeductions}
          data={deductionsData}
          pagedMeta={pagedMeta}
          loading={loading}
          handlePerRowsChange={handlePerRowsChange}
          handlePageChange={handlePageChange}
        />
      ),
      name: 'Deductions',
      icon: 'fas fa-minus-circle',
      visible: true,
    },
    extraPayments: {
      content: (
        <ExtraPaymentTab
          columns={columnsExtraPayment}
          data={extraPaymentsData}
          pagedMeta={pagedMeta}
          loading={loading}
          handlePerRowsChange={handlePerRowsChange}
          handlePageChange={handlePageChange}
        />
      ),
      name: 'Extra Payments',
      icon: 'fas fa-plus-circle',
      visible: false,
    },
    raises: {
      content: (
        <RaisesTab
          columns={columnsRaises}
          data={raiseData}
          pagedMeta={pagedMeta}
          loading={loading}
          handlePerRowsChange={handlePerRowsChange}
          handlePageChange={handlePageChange}
        />
      ),
      name: 'Raises',
      icon: 'fas fa-arrow-up',
      visible: false,
    },
    bonuses: {
      content: (
        <BonusesTab
          columns={columnsBonuses}
          data={bonusesData}
          pagedMeta={pagedMeta}
          loading={loading}
          handlePerRowsChange={handlePerRowsChange}
          handlePageChange={handlePageChange}
        />
      ),
      name: 'Bonuses',
      icon: 'fas fa-gift',
      visible: true,
    },
    submitted: {
      content: (
        <SubmittedTab
          columns={columnsPayroll}
          data={[]}
          pagedMeta={pagedMeta}
          loading={loading}
          handlePerRowsChange={handlePerRowsChange}
          handlePageChange={handlePageChange}
        />
      ),
      name: 'Submitted',
      icon: 'fas fa-check-circle',
      visible: false,
    },
  };

  const isVisible = (tabKey: string) => {
    return (payrollTabs as any)[tabKey]?.visible;
  };

  const getActionButton = () => {
    switch (activeTab) {
      case 'payroll':
        return (
          <Button color="primary" onClick={toggleBulkImport}>
            <i className="fas fa-plus mr-2" />
            Bulk Import
          </Button>
        );
      case 'deductions':
        return (
          <Button color="primary" onClick={toggleDeduction}>
            <i className="fas fa-plus mr-2" />
            Deduction
          </Button>
        );
      case 'extraPayments':
        return (
          <Button color="primary" onClick={toggleExtraPayment}>
            <i className="fas fa-plus mr-2" />
            Extra Payment
          </Button>
        );
      case 'raises':
        return (
          <Button color="primary" onClick={toggleRaise}>
            <i className="fas fa-plus mr-2" />
            Raise
          </Button>
        );
      case 'bonuses':
        return (
          <Button color="primary" onClick={toggleBonuses}>
            <i className="fas fa-plus mr-2" />
            Bonuses
          </Button>
        );
      default:
        return null;
    }
  };

  const heroActions = (
    <>
      <Button color="secondary" outline onClick={toggleCoverSheet} style={ghostActionStyle}>
        <i className="fas fa-file-alt mr-2" />
        Cover Sheet
      </Button>
      <Can moduleName="CoverSheet" functionName="Submit">
        <>
          <Button
            id="submitPayrollButton"
            color="secondary"
            outline
            style={ghostActionStyle}
            onClick={handleSubmitPayroll}
            disabled={
              coverSheetStatusLoading ||
              submitPayrollLoading ||
              !coverSheetStatus.exists ||
              coverSheetStatus.status !== 'APPROVED'
            }
          >
            <i className="fas fa-check mr-2" />
            {submitPayrollLoading ? 'Submitting...' : 'Submit Payroll'}
          </Button>
          {(!coverSheetStatus.exists || coverSheetStatus.status !== 'APPROVED') && (
            <UncontrolledTooltip placement="top" target="submitPayrollButton">
              {!coverSheetStatus.exists
                ? 'Cover Sheet must be approved before submitting payroll'
                : coverSheetStatus.status === 'REJECTED'
                ? 'Cover Sheet was rejected. Please review and get approval before submitting payroll'
                : 'Cover Sheet must be approved before submitting payroll'}
            </UncontrolledTooltip>
          )}
        </>
      </Can>
      <Can moduleName="CoverSheet" functionName="Download">
        <>
          <Button
            id="downloadPayrollButton"
            color="primary"
            style={downloadActionStyle}
            onClick={handleDownloadPayroll}
            disabled={coverSheetStatusLoading || downloadPayrollLoading || !coverSheetStatus.submitted}
          >
            <i className="fas fa-download mr-2" />
            {downloadPayrollLoading ? 'Downloading...' : 'Download Payroll'}
          </Button>
          {!coverSheetStatus.submitted && (
            <UncontrolledTooltip placement="top" target="downloadPayrollButton">
              Payroll must be submitted before download
            </UncontrolledTooltip>
          )}
        </>
      </Can>
    </>
  );

  return (
    <>
      <CommonHeader />

      <DeductionDetail
        data={deductionDetailsData}
        isOpen={isDeductionDetailsOpen}
        toggle={() => setIsDeductionDetailsOpen(!isDeductionDetailsOpen)}
      />

      <ExtraPaymentDetail
        data={extraPaymentDetailsData}
        isOpen={isExtraPaymentDetailsOpen}
        toggle={() => setIsExtraPaymentDetailsOpen(!isExtraPaymentDetailsOpen)}
      />

      <RaiseDetail
        data={raiseDetailsData}
        isOpen={isRaiseDetailsOpen}
        toggle={() => setIsRaiseDetailsOpen(!isRaiseDetailsOpen)}
      />

      <BonusesDetail
        data={bonusesDetailsData}
        isOpen={isBonusesDetailsOpen}
        toggle={() => setIsBonusesDetailsOpen(!isBonusesDetailsOpen)}
      />

      <BulkImportModal
        isOpen={isBulkImportOpen}
        toggle={toggleBulkImport}
        isFormOpen={isBulkImportFormOpen}
        toggleForm={toggleBulkImportForm}
        searchStaffName={searchStaffNameByBulkImport}
        onChangeSearch={(value) => setSearchStaffNameByBulkImport(value)}
        employees={employeesByBulkImport || []}
        isSelectedAll={isSelectedAllStaff}
        selectedStaff={selectedStaff}
        onToggleSelectAll={handleToggleSelectAllStaff}
        onSelectStaff={handleSelectStaff}
        payCode={payCode}
        setPayCode={setPayCode}
        payCodes={payCodes}
      />

      <DeductionModal
        isOpen={isDeductionOpen}
        toggle={toggleDeduction}
        employees={employees || []}
        onCreate={handleDeductionCreated}
      />

      <ExtraPaymentModal
        isOpen={isExtraPaymentOpen}
        toggle={toggleExtraPayment}
        employees={employees || []}
        extraPaymentStaff={extraPaymentStaff}
        setExtraPaymentStaff={setExtraPaymentStaff}
        extraPaymentType={extraPaymentType}
        setExtraPaymentType={setExtraPaymentType}
        extraPaymentAmount={extraPaymentAmount}
        setExtraPaymentAmount={setExtraPaymentAmount}
        extraPaymentAddingDate={extraPaymentAddingDate}
        setExtraPaymentAddingDate={setExtraPaymentAddingDate}
        extraPaymentReason={extraPaymentReason}
        setExtraPaymentReason={setExtraPaymentReason}
        extraPaymentDocumentSelected={extraPaymentDocumentSelected}
        setExtraPaymentDocumentSelected={setExtraPaymentDocumentSelected}
        extraPaymentReceiptSelected={extraPaymentReceiptSelected}
        setExtraPaymentReceiptSelected={setExtraPaymentReceiptSelected}
        documentInputRef={documentInputRef}
        receiptInputRef={receiptInputRef}
        handleDocumentChange={handleDocumentChange}
        handleReceiptChange={handleReceiptChange}
        handleCustomButtonDocumentClick={handleCustomButtonDocumentClick}
        handleCustomButtonReceiptClick={handleCustomButtonReceiptClick}
        handleSubmitExtraPayment={handleSubmitExtraPayment}
      />

      <RaiseModal
        isOpen={isRaiseOpen}
        toggle={toggleRaise}
        employees={employees || []}
        raiseStaff={raiseStaff}
        setRaiseStaff={setRaiseStaff}
        raiseReason={raiseReason}
        setRaiseReason={setRaiseReason}
        raiseCurrentAmount={raiseCurrentAmount}
        raiseAmount={raiseAmount}
        setRaiseAmount={setRaiseAmount}
        raiseDateItBecomesEffectiveOn={raiseDateItBecomesEffectiveOn}
        setRaiseDateItBecomesEffectiveOn={setRaiseDateItBecomesEffectiveOn}
        raiseFileSelected={raiseFileSelected}
        setRaiseFileSelected={setRaiseFileSelected}
        fileInputRef={fileInputRef}
        handleRaiseFileChange={handleRaiseFileChange}
        handleCustomButtonClick={handleCustomButtonClick}
        handleSubmitRaise={handleSubmitRaise}
      />

      <BonusesModal
        isOpen={isBonusesOpen}
        toggle={toggleBonuses}
        employees={employees || []}
        bonusesStaff={bonusesStaff}
        setBonusesStaff={setBonusesStaff}
        bonusesReason={bonusesReason}
        setBonusesReason={setBonusesReason}
        bonusesAmount={bonusesAmount}
        setBonusesAmount={setBonusesAmount}
        bonusesDateItBecomesEffectiveOn={bonusesDateItBecomesEffectiveOn}
        setBonusesDateItBecomesEffectiveOn={setBonusesDateItBecomesEffectiveOn}
        bonusesNumberOfPayments={bonusesNumberOfPayments}
        setBonusesNumberOfPayments={setBonusesNumberOfPayments}
        handleSubmitBonuses={handleSubmitBonuses}
      />

      <CoverSheetModal
        isOpen={isCoverSheetOpen}
        toggle={toggleCoverSheet}
        coverSheetStartDate={coverSheetStartDate}
        coverSheetEndDate={coverSheetEndDate}
        onStatusChange={async () => {
          try {
            const startDate = moment(selectedWeekStart).format('YYYY-MM-DD');
            const endDate = moment(selectedWeekStart).endOf('isoWeek').format('YYYY-MM-DD');
            const result = await PayrollService(token).coverSheetGetStatus(currentSchool.value, startDate, endDate);
            setCoverSheetStatus(result?.data || { exists: false });
          } catch (error) {
            setCoverSheetStatus({ exists: false });
          }
        }}
      />

      <Container className="mt--8" fluid>
        <Card className="bg-secondary shadow">
          <CardHeader>
            <h2 className="mb-3">Payroll</h2>
            <WeekHero
              weekStart={selectedWeekStart}
              onPrev={() => stepWeek(-1)}
              onNext={() => stepWeek(1)}
              onThisWeek={goToThisWeek}
              isCurrentWeek={isCurrentWeek}
              actions={heroActions}
            />
            <div className="mt-3">
              <PayrollOverviewCardInfo
                weekStartDate={moment(selectedWeekStart).format('YYYY-MM-DD')}
                weekEndDate={moment(selectedWeekStart).endOf('isoWeek').format('YYYY-MM-DD')}
              />
            </div>
            <Row className="mt-3">
              <Col xs="12">
                <Nav tabs>
                  {(Object.keys(payrollTabs) as Array<keyof typeof payrollTabs>).map((tabKey) => {
                    const tab = (payrollTabs as any)[tabKey];
                    if (!isVisible(tabKey)) return null;
                    return (
                      <NavItem key={tabKey}>
                        <NavLink
                          className={`${activeTab === tabKey ? 'active' : ''}`}
                          onClick={() => setActiveTab(tabKey)}
                          style={customStyles.navLink}
                        >
                          {tab.icon && <i className={`${tab.icon} mr-2`} />}
                          {tab.name}
                          {loading ? (
                            <span
                              className="ml-2"
                              style={{
                                display: 'inline-block',
                                width: '24px',
                                height: '16px',
                                background: '#e3e9f2',
                                borderRadius: '4px',
                                verticalAlign: 'middle',
                                animation: 'skeleton-loading 1.2s infinite linear alternate',
                              }}
                            />
                          ) : (
                            <Badge color="info" className="ml-2">
                              {getTotalByTab(tabKey)}
                            </Badge>
                          )}
                        </NavLink>
                      </NavItem>
                    );
                  })}
                </Nav>
              </Col>
            </Row>
          </CardHeader>

          <CardBody>
            <Row className="mb-3">
              <Col xs="12" className="d-flex justify-content-end">
                {getActionButton()}
              </Col>
            </Row>

            <Row>
              <Col xs="12">
                <TabContent activeTab={activeTab}>
                  {Object.keys(payrollTabs).map((tabKey: string) => {
                    const tab = (payrollTabs as any)[tabKey];
                    if (!isVisible(tabKey)) return null;
                    return (
                      <TabPane key={tabKey} tabId={tabKey}>
                        {activeTab === tabKey && tab.content}
                      </TabPane>
                    );
                  })}
                </TabContent>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default Payroll;
